const ProjectManagementStatusEnum = {
  ACTIVE: 'ACTIVE',
  DISABLED: 'DISABLED',


  };

export default ProjectManagementStatusEnum;